/*
 * EXPORTING REDUCERS and SAGAS
 */
import vote from './actions/vote';

// All sagas to be loaded
export default [
  vote,
];
